import React from 'react';
import { Helmet } from 'react-helmet-async';

import appleTouchIcon from 'assets/img/favicon/homeowner/apple-touch-icon.png';
import favicon16 from 'assets/img/favicon/homeowner/favicon-16x16.png';
import favicon32 from 'assets/img/favicon/homeowner/favicon-32x32.png';
import manifest from 'assets/img/favicon/homeowner/site.webmanifest';

const Favicon = () => (
  <Helmet>
    <link href={appleTouchIcon} rel="apple-touch-icon" sizes="180x180" />
    <link href={favicon32} rel="icon" sizes="32x32" type="image/png" />
    <link href={favicon16} rel="icon" sizes="16x16" type="image/png" />
    <link href={manifest} rel="manifest" />
  </Helmet>
);

export { Favicon };
